import RulesComponent from '../components/rules/rules'

const Rules = () => <RulesComponent />

export default Rules;